<template>
  <div class="flex justify-start">
    <span class="ml-2">
      <svg
        v-if="isLoading"
        width="50"
        height="25"
        viewBox="0 0 50 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0H42C46.4183 0 50 3.58172 50 8V17C50 21.4183 46.4183 25 42 25H8C3.58172 25 0 21.4183 0 17V0Z"
          :fill="gradient"
          fill-opacity="0.9"
        />
        <circle cx="12" cy="12.5" r="4" :fill="dotColor">
          <animate attributeName="r" values="4;6;4" dur="1s" repeatCount="indefinite" begin="0s" />
        </circle>
        <circle cx="25" cy="12.5" r="5" :fill="dotColor">
          <animate
            attributeName="r"
            values="5;7;5"
            dur="1s"
            repeatCount="indefinite"
            begin="0.2s"
          />
        </circle>
        <circle cx="38" cy="12.5" r="4" :fill="dotColor">
          <animate
            attributeName="r"
            values="4;6;4"
            dur="1s"
            repeatCount="indefinite"
            begin="0.4s"
          />
        </circle>
        <defs>
          <linearGradient
            id="paint0_linear_2453_64506"
            x1="-14.5833"
            y1="-12.5"
            x2="73.7335"
            y2="33.2412"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#6E53F2" />
            <stop offset="1" stop-color="#FF4B43" />
          </linearGradient>
        </defs>
      </svg>
      <span v-else class="loading-msg">
        <span class="scrolling-msg-wrapper">
          <span class="scrolling-msg" ref="scrollMsg">
            {{ displayedText }}<span class="dot-anim-group"><span class="dot-anim">.</span><span class="dot-anim">.</span><span class="dot-anim">.</span></span>
          </span>
        </span>
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, nextTick } from 'vue';

const props = defineProps<{ dark?: boolean, msg?: string }>();
const emit = defineEmits(['scroll-bottom']);

const isLoading = ref(true);
const displayedText = ref('');
const prefix = 'Buscando informações sobre ';
const scrollMsg = ref<HTMLElement | null>(null);

async function typeWriter(fullText: string) {
  displayedText.value = '';
  for (let i = 0; i < fullText.length; i++) {
    displayedText.value += fullText[i];
    await new Promise(r => setTimeout(r, 8));
  }
  await nextTick();
  emit('scroll-bottom');
}

onMounted(() => {
  setTimeout(async () => {
    isLoading.value = false;
    await nextTick();
    const fullMsg = `${prefix} "${(props.msg || '').slice(0, 35)}"`;
    await typeWriter(fullMsg);
  }, 2000);
});

const dotColor = computed(() => (props.dark ? '#fff' : '#E2E6E9'));
const gradient = 'url(#paint0_linear_2453_64506)';
</script>

<style scoped>
.loading-msg {
  font-size: .8rem;
  color: #6E53F2;
  font-weight: 500;
}
.scrolling-msg-wrapper {
  display: inline-block;
  overflow: hidden;
  vertical-align: bottom;
  position: relative;
}
.scrolling-msg {
  display: inline;
  transition: none;
  will-change: auto;
  vertical-align: bottom;
  white-space: normal;
  word-break: break-word;
}
.dot-anim-group {
  white-space: nowrap;
}
.dot-anim {
  display: inline-block;
  animation: bounce 1.2s infinite;
}
.dot-anim:nth-of-type(1) { animation-delay: 0s; }
.dot-anim:nth-of-type(2) { animation-delay: 0.2s; }
.dot-anim:nth-of-type(3) { animation-delay: 0.4s; }

@keyframes bounce {
  0%, 80%, 100% { transform: translateY(0); opacity: 1; }
  40% { transform: translateY(-6px); opacity: 0.7; }
}
</style>
